export default "* Hvad har brummeren været brugt til i jægerstenalderen?\n* Hvad er magi og åndemaneri?\n* Hvad er det en shaman fra jægerstenalderen kan?";